import React from 'react';
import { styled } from '@mui/material/styles';
import Slide from '@mui/material/Slide';
import {useTranslation} from 'react-i18next';
import {Container, Typography} from "@mui/material";
import {BrowserView, isAndroid, isIOS, isIOS13, MobileView} from "react-device-detect";

const PREFIX = 'AdsApp';

const classes = {
  backdrop: `${PREFIX}-backdrop`,
  mainContainer: `${PREFIX}-mainContainer`,
  browserContainer: `${PREFIX}-browserContainer`,
  mobileContainer: `${PREFIX}-mobileContainer`,
  browserIconContainer: `${PREFIX}-browserIconContainer`,
  mobileIconContainer: `${PREFIX}-mobileIconContainer`,
  linksStyle: `${PREFIX}-linksStyle`
};

const StyledSlide = styled(Slide)((
  {
    theme
  }
) => ({
  [`& .${classes.backdrop}`]: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },

  [`& .${classes.mainContainer}`]: {
    width: '100%',
    maxWidth: '600px',
    backgroundColor: "#303030",
    borderRadius: '4px',
    padding: '16px',
    textAlign: 'center',
    margin: '0 auto',
  },

  [`& .${classes.browserContainer}`]: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around',
    paddingTop: '2rem',
  },

  [`& .${classes.mobileContainer}`]: {
    paddingTop: '1rem',
  },

  [`& .${classes.browserIconContainer}`]: {
    display: 'flex',
    flexDirection: 'column',
    'WebkitTransition': 'all .4s ease',
    'MozTransition': 'all .4s ease',
    'OTransition': 'all .4s ease',
    'transition': 'all .4s ease',
    opacity: '0.6',
    '&:hover': {
      'WebkitTransition': 'all .4s ease',
      'MozTransition': 'all .4s ease',
      'OTransition': 'all .4s ease',
      'transition': 'all .4s ease',
      opacity: '1'
    }
  },

  [`& .${classes.mobileIconContainer}`]: {
    display: 'flex',
    flexDirection: 'column'
  },

  [`& .${classes.linksStyle}`]: {
    color: '#B59A4F',
    fontWeight: 'bold',
    marginBottom: '1rem',
  }
}));

const AdsApp = (props) => {

  const {t, i18n} = useTranslation();
  return (
    <StyledSlide direction="up" in={props.backdropStatus} mountOnEnter unmountOnExit>
      <Container className={classes.backdropContainer}>
        <div className={classes.mainContainer}>
          <Typography variant="h3" className={classes.redirectTitle}>
            {t('myDesign.informations.appModalTitle')}
          </Typography>
          <BrowserView>
            <Container className={classes.browserContainer}>
              <div className={classes.browserIconContainer}>
                <a
                  href="https://apps.apple.com/us/app/artdesignstory/id1536423226"
                  className={classes.linksStyle}
                >
                  <i className="fab fa-app-store-ios fa-5x"></i>
                </a>
                {t('myDesign.informations.appleStore')}
              </div>
              <div className={classes.browserIconContainer}>
                <a
                  className={classes.linksStyle}
                  href="https://play.google.com/store/apps/details?id=fr.artdesignstory.artdesignstory_app.dev&hl=fr&ah=sbX-QgqfBMT2M_EZ0vh6_Vo7O5U"
                >
                  <i className="fab fa-google-play fa-5x"></i>
                </a>
                {t('myDesign.informations.playStore')}
              </div>
            </Container>
          </BrowserView>
          <MobileView>
            <Container className={classes.mobileContainer}>
              {isIOS || isIOS13 ?
                <div className={classes.mobileIconContainer}>
                  <a
                    href="https://apps.apple.com/fr/app/artdesignstory/id1536423226"
                    className={classes.linksStyle}
                  >
                    <i className="fab fa-app-store-ios fa-5x"></i>
                  </a>
                  {t('myDesign.informations.app-link.download')}
                </div>
                :
                isAndroid ?
                  <div className={classes.mobileIconContainer}>
                    <a
                      href="https://play.google.com/store/apps/details?id=fr.artdesignstory.artdesignstory_app.dev&hl=fr&ah=sbX-QgqfBMT2M_EZ0vh6_Vo7O5U"
                      className={classes.linksStyle}
                    >
                      <i className="fa fa-google-play fa-5x"></i>
                    </a>
                    {t('myDesign.informations.app-link.download')}
                  </div>
                  :
                  <div className={classes.mobileIconContainer}>
                    <a href="/home" className={classes.linksStyle}>
                      <i className="fa fa-home fa-5x"></i>
                    </a>
                    {t('bottomMenu.home')}
                  </div>
              }
            </Container>
          </MobileView>
        </div>
      </Container>
    </StyledSlide>
  );
}

export default AdsApp;
